module.exports = __webpack_public_path__ + "img/3-4.d4bd13f7.jpg";